import { Injectable } from '@angular/core';
import { Amenity, Tenant } from '@generated/tcea/models';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AbstractBrandService {
  abstract create(brand: Partial<Tenant>): Observable<Tenant>;

  abstract get(): Observable<Tenant[]>;

  abstract getOne(brandId: string): Observable<Tenant>;

  abstract save(request: Partial<Tenant>, brandId: string): Observable<any>;

  abstract updateAggregators(
    brandId: string,
    aggregatorConfigs: Tenant['aggregatorConfigurations'],
  ): Observable<Tenant>;

  abstract getAmenities(brandId: string): Observable<Amenity[]>;

  abstract saveAmenities(brandId: string, amenities: Amenity[]): Observable<Amenity[]>;
}
